import React from 'react';

import PropTypes from 'prop-types';

import Button from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';

import { FooterActions } from './DefaultFooter';
import { FooterActionsProps } from '../types';

const DefaultFooterActions = ({
  today,
  isTodaySelectable = true,
}: FooterActionsProps) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  return (
    <FooterActions>
      <Button
        onClick={today}
        size={Button.SIZES.SMALL}
        disabled={!isTodaySelectable}
      >
        {T.translate('TODAY')}
      </Button>
    </FooterActions>
  );
};

DefaultFooterActions.displayName = 'DefaultFooterActions';

DefaultFooterActions.propTypes = {
  today: PropTypes.func.isRequired,
};

export default DefaultFooterActions;
